<template>
  <div class="relative">
    <span class="group flex relative items-center select-none hover:bg-theme/5 rounded-full ring-0 hover:ring-2 hover:ring-theme/20 cursor-pointer">
      <span
        v-if="user.firstname"
        class="hidden md:inline-block font-semibold truncate max-w-[200px] pl-4"
        v-text="t('navdropper.greeting')+', '+ user.firstname"
        />

      <ui-navigation-profile-avatar />

      <div class="hidden group-hover:block absolute top-full right-0 z-30">
        <div class="pt-2">
          <div class="min-w-[200px] ui-list">
            <div v-text="user.email" />
            <hr>
            <ui-link to="/profile" :text="t('navdropper.profile')"/>
            <ui-link to="/home/settings/account" :text="t('navdropper.settings')"/>
            <hr>
            <ui-link class="text-red-400 hover:text-red-600" :text="t('navdropper.logout')" @click="logout"/>
          </div>
        </div>
      </div>
    </span>

    <div class="absolute top-full right-0 mt-2 z-10 group/upgrade">
      <ui-category-badge
        :text="'✨ '+t('navdropper.upgrade.badge')"
        class="!bg-orange-600/40 hover:!bg-orange-400/80 font-bold !text-orange-800 cursor-pointer"
        />

      <div class="hidden group-hover/upgrade:block absolute top-full pt-2  right-0">
        <div class="ui-card ui-list dense flex flex-col text-nowrap">
          <h5 v-text="t('navdropper.upgrade.licenses')"/>
          <hr>
          <ui-link
            :to="methodProductRoute('full-seat')"
            :text="t('navdropper.upgrade.seat')"
            />
          <ui-link
            :to="methodProductRoute('simulator-day-license')"
            :text="t('navdropper.upgrade.daylicensesim')"
            />
          <ui-link
            :to="methodProductRoute('questions-day-license')"
            :text="t('navdropper.upgrade.daylicensequestions')"
            />
          <hr>
          <ui-link
            :to="'/pricing'"
            :text="t('navdropper.upgrade.all')"
            />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n()
</script>
